<template>
  <v-dialog v-model="dialog" width="780px">
    <v-card class="" v-if="item">
      <v-card-title class="blue darken-4 white--text">
        SỬA CHUYÊN CẦN
        <v-spacer></v-spacer>
        <v-icon color="white" @click="cancel">close</v-icon>
      </v-card-title>
      <v-card-text class="px-3 pb-0 pt-6">
        <v-form ref="form" class="">
          <div class="d-flex">
            <v-col cols="4" class="py-0">
              <div class="text-caption my-0">Học sinh</div>
              <CardStudentName style="margin-top: -8px" :isShowCode="false" :student="item.student" />
            </v-col>
            <v-col class="d-flex justify-space-between align-center py-0" cols="8">
              <div>
                <div class="text-caption my-0">Ngày sinh</div>
                <span class="black--text">{{ item.student.dob | ddmmyyyy }}</span>
              </div>
              <v-spacer></v-spacer>
              <div>
                <div class="text-caption my-0">Mã số</div>
                <span class="black--text">{{ item.student.code_short }}</span>
              </div>
              <v-spacer></v-spacer>
              <div>
                <div class="text-caption my-0">Lớp</div>
                <span class="black--text">{{ item.class | getStudentClassName }}</span>
              </div>
            </v-col>
          </div>
          <v-row no-gutters class="pl-3 pb-3">
            <v-col class="d-flex align-center py-0" cols="12">
              <div class="py-0 px-0">
                Ngày <span class="normal-text">{{ item && item.date ? item.date : '' | ddmmyyyy }}</span>
              </div>
            </v-col>
          </v-row>
          <v-row no-gutters class="pl-3">
            <v-col class="d-flex align-center py-0" cols="12">
              <div style="width: 100%">
                <RadioAbsentStatus :item="item" @change="change" />
              </div>
            </v-col>
          </v-row>
          <v-row no-gutters class="pl-3" style="min-height: 46px">
            <v-col class="d-flex align-center py-0" cols="12">
              <div style="width: 100%" v-if="!present">
                <RadioAbsentType :item="item" @change="changeType" />
              </div>
              <div style="width: 100%" v-if="present">
                <RadioPresentType :item="item" @change="changeType" />
              </div>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions class="pa-6">
        <v-btn color="primary" outlined @click="cancel">Hủy</v-btn>
        <v-spacer></v-spacer>
        <v-btn class="white--text" depressed color="#0D47A1" :disabled="status === oldStatus" @click="save"
          >Xác nhận</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import CardStudentName from '@/views/student/components/CardStudentName.vue'
import { mapActions } from 'vuex'
import RadioAbsentStatus from './RadioAbsentStatus.vue'
import RadioAbsentType from './RadioAbsentType.vue'
import RadioPresentType from './RadioPresentType.vue'

export default {
  components: {
    CardStudentName,
    RadioAbsentType,
    RadioPresentType,
    RadioAbsentStatus
  },
  props: {
    state: Boolean,
    item: Object
  },
  data() {
    return {
      date: null,
      dialog: false,
      value: 'time',
      status: '',
      present: null,
      oldStatus: ''
    }
  },
  watch: {
    state() {
      this.dialog = true
    },
    item: {
      handler(newValue) {
        if (newValue) {
          this.oldStatus = newValue.status
          this.status = newValue.status
          this.present = newValue.present
        }
      },
      immediate: true,
      deep: true
    }
  },
  methods: {
    ...mapActions('Diligence', ['updateDiligence']),
    async save() {
      if (this.$refs.form.validate()) {
        this.$loading.active = true
        const data = {
          present: this.present ? 'true' : 'false',
          status: this.status
        }
        const update = await this.updateDiligence({ id: this.item.id, ...data })
        if (update) {
          this.$alert.success('Sửa chuyên cần thành công')
          this.cancel()
          this.$emit('refresh')
          this.$loading.active = false
        } else {
          this.$alert.error('Sửa chuyển cần thât bại')
          this.$loading.active = false
        }
      }
    },
    cancel() {
      this.dialog = false
    },
    change(data) {
      this.present = data
      this.status = this.present ? 'present' : 'absent'
    },
    changeType(data) {
      this.status = data
    }
  },
  filters: {
    getStudentClassName(clazz) {
      if (!clazz) return '---'
      return clazz.title
    }
  }
}
</script>

<style scoped>
.normal-text {
  font-size: 16px;
  color: black;
  font-family: 'Roboto';
}
</style>
